import { getEffectiveCost } from './quickPriceListModel';
import { hasPriceRuleSelection } from '../../utils/complexPriceRules';
import { SHARED_RETAIL_FIELDS } from '../../utils/sharedRetailConfiguration';

const AVAILABILITY_FIELDS = {
  metricUnit: 'Unidad de venta',
  unitWeightKg: 'Peso por unidad (kg)',
};

// These are display categories only. Keep the server's readiness and sale
// restrictions intact even when an unconfigured price needs no warning.
const selectCompletion = (completion, includeField, includeWarnings) => {
  if (!completion) return null;
  const missingFields = (completion.missingFields || []).filter(includeField);
  return {
    ...completion,
    missingFields,
    warnings: includeWarnings ? completion.warnings || [] : [],
    isReady: missingFields.length === 0,
    isDraft: Boolean(completion.isDraft && missingFields.length),
  };
};

export const getQuickAvailabilityCompletion = (format) => selectCompletion(
  format.completion, (field) => !format.sharesRetailConfiguration && Object.hasOwn(AVAILABILITY_FIELDS, field), false
);

export const getQuickFormatCompletion = (format) => selectCompletion(
  format.completion,
  (field) => !Object.hasOwn(AVAILABILITY_FIELDS, field)
    && !(format.sharesRetailConfiguration && SHARED_RETAIL_FIELDS.includes(field))
    && (field !== 'sellingPrice' || hasPriceRuleSelection(format.priceRule, format.stockPriceRule)),
  true
);

export const getQuickAvailabilityWarnings = (format) => (
  getQuickAvailabilityCompletion(format)?.missingFields || []
).map((field) => `Falta: ${AVAILABILITY_FIELDS[field]}.`);

export const getQuickPriceWarnings = (format, { draft = {}, error = '' } = {}) => {
  const messages = [];
  if (error) messages.push(error);
  if (format.priceRuleAssignment?.type === 'most_used') messages.push('Regla aplicada automáticamente: se usó la regla más frecuente de este formato en la sucursal. Revisa que corresponda.');
  const price = Object.hasOwn(draft, 'price') ? draft.price : format.sellingPrice;
  const cost = getEffectiveCost(format).effective;
  if (['number', 'string'].includes(typeof price) && String(price).trim() !== ''
    && Number.isInteger(Number(price)) && Number(price) >= 0 && cost !== null && Number(price) < cost) {
    messages.push('Bajo costo: el precio final está por debajo del costo calculado.');
  }
  return messages;
};

export const summarizeQuickPriceWarnings = (formats, warningsById) => {
  const affected = formats.filter((format) => warningsById[format.id]?.length);
  if (!affected.length) return [];
  return [`${affected.length} ${affected.length === 1 ? 'formato visible con avisos' : 'formatos visibles con avisos'}.`,
    ...affected.map((format) => `${format.productFormatName || format.clientType || 'Formato'}: ${warningsById[format.id].join(' ')}`)];
};
